import styled from 'styled-components';
import { MdAdd, MdDelete, MdEdit, MdDone, MdUndo } from 'react-icons/md';

export const Container = styled.div``;

export const WrapperTable = styled.div`
  margin-top: 30px;
`;

export const WrapperAdd = styled.div`
  margin-left: 20px;
`;

export const AddIcon = styled(MdAdd).attrs({ size: '20px' })`
  color: #fff;
`;

export const DeleteIcon = styled(MdDelete).attrs({ size: '19px' })`
  color: #F27160;
  cursor: pointer;
`;

export const EditIcon = styled(MdEdit).attrs({ size: '19px' })`
  color: #122d58;
  cursor: pointer;
`;

export const BaixarIcon = styled(MdDone).attrs({ size: '19px' })`
  color: #44DD30;
  cursor: pointer;
`;

export const EstornarIcon = styled(MdUndo).attrs({ size: '19px' })`
  color: #F27160;
  cursor: pointer;
`;

export const WrapperPopover = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PopoverText = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #7b7b7b;
  margin-bottom: 15px;
`;

export const PopoverButton = styled.button`
  background-color: ${(props) => (props.primary ? '#122d58' : '#fff')};
  color: ${(props) => (props.primary ? '#fff' : '#122d58')};
  border: 1px solid #122d58;
  border-radius: 5px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin: 0 5px;
  
  &:hover {
    background-color: ${(props) => (props.primary ? '#0f2447' : '#f5f5f5')};
  }
`;

export const StatusBadge = styled.span`
  background-color: ${(props) => props.color}15;
  color: ${(props) => props.color};
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
`;

